module.exports = __webpack_public_path__ + "static/media/al_shamel_motor.be8e5aaf.svg";